<div id="carouselExampleIndicators" class="carousel slide" *ngIf="adsList.length > 0" #carousel>
   <div class="carousel-indicators" *ngIf="adsList.length > 1">
      <button *ngFor="let ad of adsList; let i = index" type="button"
          data-bs-target="#carouselExampleIndicators" [attr.data-bs-slide-to]="i"
          [class.active]="i === 0" [attr.aria-current]="i === 0 ? 'true' : null"
          [attr.aria-label]="'Slide ' + (i + 1)">
      </button>
  </div>
  <div class="carousel-inner">
    <div *ngFor="let ad of adsList; let i = index" class="carousel-item" [class.active]="i === 0">
      <img [src]="ad.bigthumb_url"
      onerror="this.src='/assets/images/default_company_image.png'"
      class="d-block"
      alt="Image"
      (click)="handleAdClick(ad)"
      (keydown.enter)="handleAdClick(ad)"
      tabindex="0"
      role="button">
    </div>
  </div>
</div>
<div class="section-loader text-center" *ngIf="isAdsLoading">
  <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">Loading...</span>
  </div>
</div>
